import React from "react";
import "./ConfirmDialog.css";

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, details, confirmText = "Confirm", cancelText = "Cancel", variant = "default" }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleOverlayClick}>
      <div className={`confirm-dialog ${variant}`}>
        <div className="confirm-dialog-header">
          <h3 className="confirm-dialog-title">{title}</h3>
        </div>
        
        <div className="confirm-dialog-content">
          <p className="confirm-dialog-message">{message}</p>
          
          {details && (
            <div className="confirm-dialog-details">
              {Array.isArray(details) ? (
                <ul>
                  {details.map((detail, index) => (
                    <li key={index}>{detail}</li>
                  ))}
                </ul>
              ) : (
                <p>{details}</p>
              )}
            </div>
          )}
        </div>
        
        <div className="confirm-dialog-buttons">
          <button
            type="button"
            className="confirm-dialog-cancel"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={`confirm-dialog-confirm ${variant}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;